import { AnyAction } from 'redux';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { AssessmentPayload } from 'types/assessment-payload';
import { getAssessment } from 'api/api';
import {
  changeSsiDocumentNumberAction,
  fetchAssessmentErrorAction,
  fetchAssessmentStartAction,
  fetchAssessmentSuccessAction,
} from 'actions/assessment';
import { fetchAssessmentSuccessMessages } from 'actions/messages';
import { fetchAssessmentPageAction } from 'actions/assessmentPage';
import { fetchAssessmentSummaryAction } from 'actions/assessmentSummary';
import { GET_ASSESSMENT } from 'actions/assessment/types';
import { RootReducer } from 'store/reducers';
import { CheckMessage } from '../../types/check';

const getAssessmentPage = (state: RootReducer) => state.assessmentPage;

export function* fetchAssessment({
  documentId,
  documentVersion,
  ssiDocumentNumber,
}: AnyAction) {
  let assessmentPayload = undefined;

  try {
    yield put(fetchAssessmentStartAction());

    const { data: assessment }: { data: AssessmentPayload } = yield call(
      getAssessment,
      documentId,
      documentVersion,
      ssiDocumentNumber
    );

    const assessmentDocumentNumber =
      assessment.ssiDetails?.ssiDocument?.documentNumber;
    let documentNumber = undefined;

    if (ssiDocumentNumber) {
      documentNumber = ssiDocumentNumber;
    } else if (assessmentDocumentNumber) {
      documentNumber = assessmentDocumentNumber;
    }

    if (documentNumber) {
      yield put(changeSsiDocumentNumberAction(documentNumber));
    }

    yield put(fetchAssessmentSuccessAction(assessment));
    yield put(
      fetchAssessmentSuccessMessages(assessment.messages as CheckMessage[])
    );

    assessmentPayload = assessment;
  } catch (e) {
    console.error(e);
    yield put(
      fetchAssessmentErrorAction(e.response?.data?.message, e.response?.status)
    );
  }

  if (assessmentPayload) {
    try {
      let assessmentPage = yield select(getAssessmentPage);
      const selectedPage = assessmentPage?.selectedPage ?? 1;
      yield put(
        fetchAssessmentPageAction(selectedPage - 1, assessmentPayload.jobToken)
      );
    } catch (e) {
      console.log(e);
    }

    try {
      yield put(fetchAssessmentSummaryAction(assessmentPayload.jobToken));
    } catch (e) {
      console.log(e);
    }
  }
}

export default function* watchFetchAssessment() {
  yield takeEvery(GET_ASSESSMENT, fetchAssessment);
}
